import type { DiceFactory } from "../../../royalur/model/dice/DiceFactory.js";
import type { RoyalUrRoll } from "./RoyalUrRoll.js";
import { RoyalUrDice } from "./RoyalUrDice.js";
import type { DiceType } from "../../../royalur/model/dice/DiceType.js";


/**
 * A factory for producing RoyalUrDice.
 */
export class RoyalUrDiceFactory implements DiceFactory {

    private readonly diceType: DiceType;

    constructor(diceType: DiceType) {
        this.diceType = diceType;
    }

    getID() {
        return this.diceType.getID();
    }

    getName(): string {
        return this.diceType.getName();
    }

    getDesc(): string {
        return this.diceType.getDesc();
    }

    getType(): DiceType {
        return this.diceType;
    }

    createDice(): RoyalUrDice {
        return new RoyalUrDice(this.diceType);
    }

    createRoll(value: number): RoyalUrRoll {
        return this.createDice().generateRoll(value);
    }

    isEquivalent(other: DiceFactory): boolean {
        if (!(other instanceof RoyalUrDiceFactory))
            return false;

        return this.diceType === other.diceType;
    }
}
